import Vue from 'vue'
import App from './App'
import router from './router'
import Tinymce from '@/components/tinymce/index.vue'

import VueQuillEditor from 'vue-quill-editor'  //引入富文本编译器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);



import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
// 视频模块
// import VuevideoPlayer from 'vue-video-player';

// import 'video.js/dist/video-js.css';

// Vue.use(VuevideoPlayer);
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
// import { createApp } from 'vue'
// let app = createApp(App)

// import vue3videoPlay from 'vue3-video-play' // 引入组件
// import 'vue3-video-play/dist/style.css' // 引入css
// app.use(vue3videoPlay)

// app.mount('#app')
// Vue.use(vue3videoPlay)

import qs from 'qs';
Vue.prototype.$qs = qs
Vue.component('tinymce', Tinymce)
//引入公共样式reset
import '../static/reset.css'
import './assets/font/iconfont.css'
//引入vuetify
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
Vue.use(Vuetify)
export default new Vuetify({ theme: {
  themes: {
    light: {
      primary: '#3472FF',
      secondary: '#ED4445',
      accent: '#FF6834',
      info:'#25A8BF',
      warning:'FFBC2F',
      error: '#ED4445',
    },
  },
},
  icons: {
      iconfont: 'mdi', // default - only for display purposes
    },})
//引入修改vuetify
import './common/css/vuetify.less'
//按需引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import { Message } from 'element-ui';
Vue.prototype.$elemessage = Message
//引入全局函数$global
import global from './utils/global.js'
Vue.prototype.$global = global
//封装axios
import * as THREE from 'three'
import {
  CSS3DRenderer,
  CSS3DObject,
} from "three/examples/jsm/renderers/CSS3DRenderer";
import {TrackballControls
} from "three/examples/jsm/controls/TrackballControls";

Vue.prototype.$TrackballControls = TrackballControls //挂载到Vue实例上面
Vue.prototype.$CSS3DRenderer = CSS3DRenderer //挂载到Vue实例上面
Vue.prototype.$CSS3DObject = CSS3DObject //挂载到Vue实例上面


Vue.prototype.$THREE = THREE //挂载到Vue实例上面

import HTTP from './http/Request.js'
HTTP.config(Vue)
import axios from 'axios'
import * as echarts from 'echarts'
import 'echarts-gl'
import 'echarts-liquidfill'
Vue.prototype.$HTTP = HTTP
Vue.prototype.$echarts = echarts //挂载到Vue实例上面
Vue.config.productionTip = false
// require('froala-editor/js/froala_editor.pkgd.min.js')
import VueCropper from 'vue-cropper' 
Vue.use(VueCropper)
import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS)
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.transformRequest = [function (data) {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]
import 'video.js/dist/video-js.css'
// import Avue from '@smallwei/avue';
// import '@smallwei/avue/lib/index.css';
// Vue.use(Avue)

import {
  Button,
  Layout,
  Input,
  Row,
  Col,
  Icon,
  Divider,
  Upload,

} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import Avue from '@smallwei/avue'
// import '@smallwei/avue/lib/index.css'
// Vue.use(Avue)
Vue.use(Button)
Vue.use(Layout)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Divider)
Vue.use(Upload)

// Require Froala Editor css files.
// require('froala-editor/css/froala_editor.pkgd.min.css')
// require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
// import VueFroala from 'vue-froala-wysiwyg'
// Vue.use(VueFroala)
new Vue({
  el: '#app',
  router,
  vuetify:new Vuetify(),
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js